import { KYDPlace } from "../../interfaces/KYDEvent";

const getStreetLine = (address: KYDPlace) => {
  const labelStreet = address.Label?.split(",")[0]?.trim();
  if (labelStreet) {
    return labelStreet;
  }
  return [address.AddressNumber, address.Street].filter(Boolean).join(" ");
};

/**
 * Formats a KYDPlace object as a properly formatted US address
 * @param address - The KYDPlace object containing address components
 * @returns A formatted address string with proper line breaks
 */
export const formatAddress = (address: KYDPlace): string => {
  if (!address) {
    return "";
  }

  const parts: string[] = [];

  const streetLine = getStreetLine(address);
  if (streetLine) {
    parts.push(streetLine);
  }

  // City, State, ZIP
  const cityStateZip: string[] = [];
  if (address.Municipality) {
    cityStateZip.push(address.Municipality);
  }
  if (address.Region) {
    cityStateZip.push(address.Region);
  }
  if (address.PostalCode) {
    cityStateZip.push(address.PostalCode);
  }

  if (cityStateZip.length > 0) {
    parts.push(cityStateZip.join(", "));
  }

  // Country (if not US)
  if (
    address.Country &&
    address.Country !== "USA" &&
    address.Country !== "US"
  ) {
    parts.push(address.Country);
  }

  return parts.join("\n");
};

/**
 * Formats a KYDPlace object as a single-line address string
 * @param address - The KYDPlace object containing address components
 * @returns A formatted address string on a single line
 */
export const formatAddressInline = (address: KYDPlace): string => {
  const parts: string[] = [];

  const streetLine = getStreetLine(address);
  if (streetLine) {
    parts.push(streetLine);
  }

  // City, State, ZIP
  const cityStateZip: string[] = [];
  if (address.Municipality) {
    cityStateZip.push(address.Municipality);
  }
  if (address.Region) {
    cityStateZip.push(address.Region);
  }
  if (address.PostalCode) {
    cityStateZip.push(address.PostalCode);
  }

  if (cityStateZip.length > 0) {
    parts.push(cityStateZip.join(", "));
  }

  // Country (if not US)
  if (
    address.Country &&
    address.Country !== "USA" &&
    address.Country !== "US"
  ) {
    parts.push(address.Country);
  }

  return parts.join(", ");
};
